
class FeaturedCollectionsManager{
    constructor(sectionId){

        // Get the section
        this.parent = document.querySelector(`#shopify-section-`+sectionId)
        // Get the elements that can be clicked on to select the collection
        this.selectors = this.parent.querySelectorAll(".featured-collection-selector")

        // Get the sliders
        this.sliders = this.parent.querySelectorAll(".featured-collections-sliders")

        // Add event listener to the sliders
        let self = this;
        for (let i = 0; i < this.selectors.length; i ++){
            this.selectors[i].addEventListener('click', function() {
                this.switchSliders(this.selectors[i]);
            }.bind(this));        }
    }

    switchSliders (selectorElement){

        // Find the active slider
        const activeSlider = this.parent.querySelector('.collection-active')
        // If the active slider wasn't clicked, deactivate the active one.
        if(activeSlider.dataset.collection != selectorElement.dataset.collection){
            // Deactivate the previous slider and it's selector.
            activeSlider.classList.add("collection-inactive")
            activeSlider.classList.remove("collection-active")

            // Pause for the previous slider to fade out.
            setTimeout(()=>{
                for(let i = 0; i < this.sliders.length; i++){
                    let slider = this.sliders[i]
                    
                    // Deactivate selector(s)
                    if(this.selectors[i].dataset.collection != selectorElement.dataset.collection){
                        this.selectors[i].classList.add("selector-inactive")
                        this.selectors[i].classList.remove("selector-active")
                    }
                    if(slider.dataset.collection == selectorElement.dataset.collection){
                        // Set max height to previous selector to 0.
                        activeSlider.classList.remove("max-h-1000")
                        activeSlider.classList.add("max-h-0")

                        // Activate the new selector.
                        selectorElement.classList.remove("selector-inactive")
                        selectorElement.classList.add("selector-active")

                        // Show the new slider.
                        slider.classList.remove("collection-inactive")
                        slider.classList.remove("max-h-0")
                        slider.classList.remove("max-h-1000")
                        slider.classList.add("collection-active")
                    }
                }

            }, 300)
        }
        
    }
    
}